module.exports = __webpack_public_path__ + "static/media/logoTasaToolayuntamientoDemo.176a2742.png";